import { useTheme } from "@/modules/theme/hooks/useTheme";

import { OptionWithColor } from "../GroupPicker";

import { createCustomOptionLabelStyles } from "./createCustomOptionLabelStyles";

type CustomOptionLabelProps = OptionWithColor;

export const CustomOptionLabel: React.FC<CustomOptionLabelProps> = ({
  color,
  label,
}) => {
  const classes = createCustomOptionLabelStyles({
    theme: useTheme(),
    color,
  });
  return (
    <div className={classes.root}>
      <span className={classes.text}>{label}</span>
    </div>
  );
};
